export const START_DATE_DEFAULT = '01.01.1970';
